export default function buttons() {
  /**
   * Adding class to button groups
   */
  $('.wp-block-buttons').each(function () {
    const count = $(this).find('.wp-block-button').length;
    $(this).addClass('wp-block-buttons--count-' + count);
    if (count > 1) {
      $(this).addClass('wp-block-buttons--multiple');
    }
  });

  /**
   * Wave button text effect
   */
  $('.wp-block-button__link, .af-submit-button, .btn-wavy-hover').each(function () {
    if ($(this).find('.btn-text').length == 2) {
      return;
    }

    const text = '<span class="btn-text">' + $(this).html() + '</span>';
    $(this).html('');
    $(this).append(text);
    $(this).append(text);
    $(this).addClass('btn-wavy-hover');
  });
}
